import { buildPathForLocale } from '@/lib/intl-seo';
import { slugifyProductName } from '@/lib/utils';

/** Canonical public product path segment (slug preferred). */
export function getProductSlug(product) {
  if (!product) return null;
  const slug = String(product.slug || '').trim();
  if (slug) return slug;
  const name = product.name || product.title;
  if (name) return slugifyProductName(name);
  return product.id || null;
}

/** Locale-aware product detail URL, e.g. /tr/product/dubai-cikolatasi-200g */
export function buildProductPath(lang, productOrSlug) {
  const slug =
    typeof productOrSlug === 'string'
      ? productOrSlug
      : getProductSlug(productOrSlug);
  const key = String(slug || '').trim();
  if (!key) return buildPathForLocale(lang, ['products']);
  return buildPathForLocale(lang, ['product', key]);
}

/** True when URL uses internal id instead of canonical slug. */
export function isLegacyProductUrl(urlSegment, product) {
  if (!urlSegment || !product?.slug) return false;
  return String(urlSegment).trim() !== String(product.slug).trim();
}
